<template>
	<div>
		<div class="text-center" v-if="loading>0">
			<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
		</div>
		<b-alert show v-else-if="error" variant="danger" class="mb-3">{{error?.error||error}}</b-alert>
		<b-form v-else-if="user" @submit.prevent="saveSettings()">
			<b-overlay :show="saving > 0" variant="dark">
				<b-card>
					<template title>
						<h4 class="card-title">Notifications <small><b-badge v-if="!$parent.$parent.user.is_pro" variant="warning" style="font-size: .8rem; vertical-align: top; position: relative; top: -10px" to="/account/billing?plan=pro&period=monthly">PRO</b-badge></small></h4>
					</template>
					<fieldset :disabled="!user.is_pro">
						<b-form-row>
							<b-col cols="12" md="6">
								<br />
								<b-form-group description="Notify your users that you are streaming when you go live. You can also manually send this notification later.">
									<b-form-checkbox switch v-model="user.notification_status" value="enabled" unchecked-value="disabled">Enable notifications</b-form-checkbox>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="6">
								<b-form-group label="Notification interval" append="hours" description="Don't send a new notification unless this amount of time has passed since the last notification.">
									<b-input-group append="hours">
										<b-form-input type="number" no-wheel v-model.number="user.notification_interval_hours" min="1" step="1"></b-form-input>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-form-row>
						<b-form-row>
							<b-col cols="12" md="6">
								<b-form-group label="Webhook URLs">
									<b-form-textarea v-model="user.notification_webhooks" rows="6" :placeholder="`discord://{WebhookID}/{WebhookToken}/\n\ntgram://{bot_token}/{chat_id}/\n\ntwitter://{ConsumerKey}/{ConsumerSecret}/{AccessToken}/{AccessSecret}`" />
									<slot description>
										<small class="form-text text-muted">One URL per line. For services such as Discord and any service supported by <a href="https://github.com/caronc/apprise/wiki#notification-services" target="_blank">apprise</a>.</small>
									</slot>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="6">
								<b-form-group label="Template">
									<b-form-textarea v-model="user.notification_template" rows="6" />
									<slot description>
										<small class="form-text text-muted">You can use the following tags: <code>{username}</code>, <code>{title}</code> (stream title) and <code>{list}</code> for the list of links.</small>
									</slot>
								</b-form-group>
							</b-col>
						</b-form-row>
						<b-alert :show="saveError" variant="danger" class="mb-3">{{saveError&&(saveError.saveError||saveError.toString())}}</b-alert>
						<div class="text-center mt-3">
							<b-button variant="primary" type="submit">Save settings</b-button>
						</div>
					</fieldset>
				</b-card>
			</b-overlay>
		</b-form>
		<div v-else>NO USER</div>
	</div>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		user: null,
	}},
	async mounted() {
		try {
			this.error = null;
			this.saveError = null;
			this.saving = 0;
			this.loading++;
			await this.load();
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async load() {
			this.user = { ...this.$parent.$parent.user };
		},
		async saveSettings() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('userData', {
					notification_status: this.user.notification_status,
					notification_webhooks: this.user.notification_webhooks,
					notification_template: this.user.notification_template,
					notification_interval_hours: this.user.notification_interval_hours,
				});
				await this.$parent.$parent.loadUserData();
				await this.load();
			} catch(e) {
				console.error(e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
